import { Injectable } from "@angular/core";
import { CalcolaDimensioniResponseDTO } from "../dto/calcola-dimensioni-responseDTO";
import { CalcolaDimensioniResponseVO } from "../vo/calcola-dimensioni-responseVO";
import { MapperInterface } from "./mapper-inteface";

@Injectable({
  providedIn: "root",
})
export class MapperCalcolaDimensioniResponse
  implements
    MapperInterface<CalcolaDimensioniResponseDTO, CalcolaDimensioniResponseVO> {
  convertVoToDto(e: CalcolaDimensioniResponseVO): CalcolaDimensioniResponseDTO {
    throw new Error("Method not implemented.");
  }
  convertDtoToVo(t: CalcolaDimensioniResponseDTO): CalcolaDimensioniResponseVO {
    let calcolaDimemsioniResponseVO: CalcolaDimensioniResponseVO = new CalcolaDimensioniResponseVO();
    calcolaDimemsioniResponseVO.documentsSize = t.documentsSize;
    calcolaDimemsioniResponseVO.totalSize = t.totalSize;
    calcolaDimemsioniResponseVO.validSize = t.validSize;
    console.log("2222223333", t, calcolaDimemsioniResponseVO);
    return calcolaDimemsioniResponseVO || new CalcolaDimensioniResponseVO();
    
  }
  convertListVoToDto(
    e: CalcolaDimensioniResponseVO[]
  ): CalcolaDimensioniResponseDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: CalcolaDimensioniResponseDTO[]
  ): CalcolaDimensioniResponseVO[] {
    throw new Error("Method not implemented.");
  }
}
